module.exports = __webpack_public_path__ + "static/media/W77F1011.35217f44.svg";